// One sticker layer drawn in SVG (inches). Same shape paths / font settings as the canvas export so what you see is what prints.
import { shapePath, textLines } from "./stickerShapes";

const API = process.env.REACT_APP_BACKEND_URL;

export const LayerView = ({ l, onPointerDown }) => {
  const common = { opacity: l.opacity ?? 1, transform: `translate(${l.x} ${l.y}) rotate(${l.rot || 0})`, onPointerDown, style: { cursor: "move" }, "data-testid": `sticker-layer-${l.id}` };
  if (l.hidden) return null;
  if (l.kind === "image") return <image {...common} href={l.url.startsWith("http") ? l.url : `${API}${l.url}`} x={-l.w / 2} y={-l.h / 2} width={l.w} height={l.h} preserveAspectRatio="none" />;
  if (l.kind === "shape") return <path {...common} d={shapePath(l.shape, l.w, l.h, l.radius)} fill={l.fill} stroke={l.strokeWidth > 0 ? l.stroke : "none"} strokeWidth={l.strokeWidth} strokeLinejoin="round" />;
  const lines = textLines(l), lh = l.size * (l.lineHeight || 1.1);
  return (
    <text {...common} textAnchor="middle" fontFamily={`"${l.font}"`} fontSize={l.size} fontWeight={l.weight || 400} fontStyle={l.italic ? "italic" : "normal"} fill={l.fill}
      stroke={l.strokeWidth > 0 ? l.stroke : "none"} strokeWidth={l.strokeWidth * 2} strokeLinejoin="round" letterSpacing={l.spacing || 0} style={{ paintOrder: "stroke fill", userSelect: "none" }}>
      {lines.map((t, i) => <tspan key={i} x="0" y={(i - (lines.length - 1) / 2) * lh} dominantBaseline="central">{t || " "}</tspan>)}
    </text>
  );
};
